/**
 * Sidebar menu for customer_type === 3.
 * When datavisionCustomer (type 3 && !dsok): datavision menus.
 * When dsok: same as default (home + admin + others).
 */
export function getMenuList(context) {
  const {
    datavisionCustomer,
    customer,
    homeMenu,
    adminMenu,
    others,
    datavisionCustomerMenu,
    mediaMenu,
    productMenu,
    kioskMenu,
    kiosk,
  } = context;

  if (!datavisionCustomer) {
    return [homeMenu, adminMenu, others].filter(Boolean);
  }
  if (kiosk) {
    return [datavisionCustomerMenu, mediaMenu, kioskMenu].filter(Boolean);
  }
  if (customer?.products === 1) {
    return [datavisionCustomerMenu, mediaMenu, productMenu].filter(Boolean);
  }
  return [datavisionCustomerMenu, mediaMenu].filter(Boolean);
}
